import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Bookable",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "arrangement",
        displayName: "Orden",
      },
      {
        fieldName: "isActive",
        displayName: "Activo",
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "rate",
        displayName: "Tipología",
      },
      {
        fieldName: "type",
        displayName: "Uso",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "isActive",
        displayName: "Activo",
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "description",
        displayName: "Descripción",
      },
      {
        fieldName: "codesSection",
        displayName: "Código promocional",
        subtitle: "Solo aquellos usuarios que introduzcan este código en el motor podrán activar esta promoción",
      },
    ],
  },
};
